import { useEffect, useRef } from 'react'

type Handler = (code: string) => Promise<boolean> | boolean

const stack: { id: number; run: Handler }[] = []
let next = 0

/** Companion scans go to the newest enabled screen only, like the hardware scanner (POS_COMPANION.md §7). */
export const useCompanionScans = (handler: Handler, enabled = true) => {
  const cb = useRef(handler)
  cb.current = handler
  useEffect(() => {
    if (!enabled) return
    const entry = { id: ++next, run: (code: string) => cb.current(code) }
    stack.push(entry)
    return () => {
      const i = stack.indexOf(entry)
      if (i >= 0) stack.splice(i, 1)
    }
  }, [enabled])
}

/** `null` when no open screen takes a scan. */
export const routeCompanionScan = async (code: string): Promise<boolean | null> => {
  const top = stack.at(-1)
  return top ? Boolean(await top.run(code)) : null
}
